/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, type InputHTMLAttributes } from "react";
import InputMask from "react-input-mask";

import {
  type FieldError,
  type FieldErrors,
  type UseFormRegister,
} from "react-hook-form";
import * as Styles from "./textInput.styles";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  disabled?: boolean;
  value?: string;
  onChange?: (val: any) => void;
  mask: any;
  register?: UseFormRegister<any>;
  property?: string;
  focus?: boolean;
  isError?: boolean;
  errors?: FieldErrors | undefined;
  showErrors?: boolean;
}

export const TextInputMask: React.FC<Props> = ({
  placeholder,
  disabled,
  onChange,
  value,
  mask,
  register,
  property,
  focus,
  isError,
  errors,
  showErrors,
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const onHandleFocus = (val: boolean) => {
    if (focus) setIsFocused(val);
  };

  const registerProps = register && property ? register(property) : {};
  const zodError = property && !!errors?.[property];

  return (
    <Styles.Container>
      <Styles.ContainerInput
        disabled={disabled}
        isFocused={isFocused}
        isError={isError ?? zodError}
      >
        <InputMask
          style={{
            color: disabled ? "#a0a0a0" : "#333",
            border: "none",
            width: "100%",
            borderColor: "transparent",
            outline: "none",
            boxSizing: "border-box",
            paddingLeft: 14,
            fontSize: 14,
            cursor: disabled ? "not-allowed" : "edit",
            fontFamily: "Inter",
          }}
          placeholder={placeholder}
          alwaysShowMask={false}
          maskChar={null}
          mask={mask}
          onChange={(ev: any) => {
            onChange?.(ev.target.value);
          }}
          value={value}
          onFocus={() => {
            onHandleFocus(true);
          }}
          onBlur={() => {
            onHandleFocus(false);
          }}
          disabled={disabled}
          {...registerProps}
        />
      </Styles.ContainerInput>
      {zodError && showErrors && (
        <p>{errors[property] && (errors[property] as FieldError)?.message}</p>
      )}
    </Styles.Container>
  );
};

TextInputMask.defaultProps = {
  placeholder: "--",
  disabled: false,
};
